module.exports = __webpack_public_path__ + "static/media/monitoramento.0fb6d051.png";